<!-- 友情链接 -->
<template>
  <div
    class="link_bg"
    :style="
      $route.query.title == '器检党建' || $route.path == '/special-column'
        ? 'background:none'
        : ''
    "
  >
    <div class="version-center friendship-link">
      <div
        class="flex flex-column"
        :class="{ fffcolor: $route.path == '/special-column' }"
      >
        <div class="link-title">
          <i class="el-icon-link" style="margin-right: 8px" />友情链接
        </div>
        <div class="link-type">
          <div
            v-for="(item, index) in linkTypes"
            :key="index"
            class="link-type-item"
            :class="{ active: activeType === index }"
            @click="handleClick(index)"
          >
            <div class="flex" style="align-items: center;">
              <div :class="{'link-expand': activeType !== index, 'link-hide': activeType === index}">
                <i
                  class="el-icon-d-arrow-left"
                />
              </div>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div v-if="activeType > -1" class="link-content">
          <div class="link-grid" v-if="linkTypes[activeType]">
            <a
              v-for="(link, i) in linkTypes[activeType].links"
              :key="i"
              :href="link.link"
              target="_blank"
              class="link-item"
            >
              {{ link.linkName }}
            </a>
          </div>
        </div>
        <!-- <div>
          <span
            v-for="(item, i) in linKArr.filter((item) => item.viewPermission)"
            :key="i"
          >
            <a
              target="_blank"
              :href="item.link"
              v-if="item.viewPermission && !item.displayImages"
              >{{ item.linkName }}
            </a>
          </span>
        </div> -->
      </div>
      <!-- <vue-seamless-scroll
        :data="
          linKArr.filter((item) => item.displayImages && item.viewPermission)
        "
        :class-option="classOption"
        class="version-center"
      >
        <div class="ul-item">
          <a
            class="li-item"
            v-for="(item, i) in linKArr.filter(
              (item) => item.displayImages && item.viewPermission
            )"
            :key="i"
            :href="item.link"
            target="_blank"
            v-if="item.displayImages && item.viewPermission"
          >
            <img :src="path + item.photoPath" :alt="item.linkName" />
          </a>
        </div>
      </vue-seamless-scroll> -->
    </div>
  </div>
</template>
<script>
import { getBlogrollList } from "@/api/index";
export default {
  linkTitle: "",
  props: [],
  data() {
    return {
      linKArr: [],
      listData: [1, 2, 3, 4, 5, 6],
      classOption: {
        // step: 7,
        // limitMoveNum: 1,
        // direction: 2,
        // singleWidth: 242,
        // waitTime: 2000
        step: 1,
        limitMoveNum: 1,
        direction: 2,
      },
      activeType: -1,
      isExpanded: false,
      linkTypes: [
        {
          name: "上级单位",
          links: [],
        },
        {
          name: "相关单位",
          links: [],
        },
        {
          name: "器检系统",
          links: [],
        },
      ],
    };
  },
  watch: {},
  computed: {
    currentLinks() {
      const links = this.linkTypes[this.activeType]?.links || [];
      // return this.isExpanded ? links : links.slice(0, 2);
    },
  },
  methods: {
    handleClick(index) {
      if (this.activeType === index) {
        this.activeType = -1;
        return;
      }
      this.activeType = index;
    },
    // 跳转第三方链接
    onMenuLinkItem(url) {
      window.open(url, "_blank");
    },
    // 切换展开/收起
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
  },
  mounted() {
    getBlogrollList({ page: 0, size: 20, linkType: 0 })
      .then((res) => {
        // this.linKArr = res.content;
        this.linkTypes[0].links = res.content || [];
      })
      .finally(() => {});
    getBlogrollList({ page: 0, size: 20, linkType: 1 })
      .then((res) => {
        this.linkTypes[1].links = res.content || [];
      })
      .finally(() => {});
    getBlogrollList({ page: 0, size: 20, linkType: 2 })
      .then((res) => {
        this.linkTypes[2].links = res.content || [];
      })
      .finally(() => {});
  },
  created() {},
};
</script>

<style lang="scss" scope>
.link_bg {
  width: 100%;
  // height: 157px;
  // background: url(../assets/images/link_bg.webp) no-repeat;
  background-size: cover;
  padding: 32px 0 0;
  // margin-bottom: 20px;
}
.friendship-link {
  margin: 0 auto 0px !important;
  b {
    display: inline-block;
    min-width: 60px;
  }
  a {
    display: inline-block;
    margin-left: 16px;
    font-weight: 400;
    font-size: 18px;
    color: #000;
    margin-bottom: 14px;
    transition: all 0.3s;
    cursor: pointer;
    &:hover {
      color: #000;
      font-weight: 800;
      transform: scale(1.01);
    }
  }
  .fffcolor {
    b,
    a {
      color: #fff;
    }
  }
  .version-center {
    width: 1200px;
    height: 58px;
    margin: 0 auto;
    overflow: hidden;
    .ul-item {
      list-style: none;
      padding: 0;
      margin: 0 auto;
      display: flex;
      .li-item {
        margin: 0;
        display: block;
        width: 240px;
        width: 240px;
        margin-right: 15px;
        img {
          width: 100%;
          height: 58px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .friendship-link {
    a {
      font-size: 16px;
    }
  }
}
.link-title {
  font-size: 24px;
  font-weight: 700;
  color: #266fff;
  padding-bottom: 5px;
  margin-bottom: 20px;
  border-bottom: 2px solid #929292;
}

.link-type {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  // margin-bottom: 16px;
  .link-type-item {
    height: 36px;
    min-width: 140px;
    border-radius: 4px;
    padding: 8px 24px 0 24px;
    background: #266fff;
    color: #fff;
    font-weight: 700;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;
    margin-bottom: 16px;
    &:hover {
      background: #c2e1ff;
      color: #266fff;
    }
    &.active {
      border-radius: 4px 4px 0 0 !important;
      height: 52px;
      background: #c2e1ff;
      color: #266fff;
      margin-bottom: 0 !important;
    }
  }
  .link-expand {
    height: 100%;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(-90deg);
  }
  .link-hide {
    height: 100%;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(90deg);
  }
}
.link-content {
  background: #c2e1ff;
  color: #266fff;
  border-radius: 0 0 4px 4px;
  padding: 16px 20px;
}
.link-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  .link-item {
    color: #266fff;
    font-size: 14px;
    font-weight: 700;
    text-decoration: none;
    transition: all 0.3s;
    &:hover {
      color: #266fff;
      text-decoration: underline;
    }
  }
}
</style>
